(function () {
    /** @ngInject */
    function calendarController($scope, $state, $http, $timeout, $document) {
        //$scope.meals    =   [];
        $scope.all_message = false;
        $scope.show_meals = false;
        $scope.last_timelist = [];
        $scope.daily_message = default_text;

        /** Error handling **/
        var available_time_dates = [];
        var available_processed = false;
        $scope.errors = { notables: false, too_late: false, waitlist: false };
        $scope.closeErrors = function () {
            $scope.errors = { notables: false, too_late: false, waitlist: false };
        };
        $scope.hasErrors = function () {
            return _.includes(_.values($scope.errors), true);
        };
        $scope.debugDay = function (day, evt) {
            evt.preventDefault();
            evt.stopPropagation();
            updateWidgetStep('Calendar-Debug', { averageValue: $scope.booking.meal.avg_gtm_price, totalValue: ($scope.booking.meal.avg_gtm_price * $scope.booking.amount), meal: $scope.booking.meal.name, mealId: $scope.booking.meal.id, amount: $scope.booking.amount, date: day.format('YYYY-MM-DD') });
            return false;
        };
        $scope.setDate = function (date, calendar) {
            if ($scope.booking.meal.type != 9 && $scope.booking.children_amount === null && $scope.booking.meal.children == 1) {
                alert(child_amount_alert);
                return false;
            }
            if (date == false) return false;
            var _date = moment.tgz(date);
            //if($scope.booking.isFullDate(_date)) return false;
            if (calendar.isOffDay(_date)) { console.log("Off day"); return false; }
            if (calendar.isDisabled(_date)) { console.log("disabled day"); return false; }
            if (calendar.isDisabledMonth(_date)) { console.log("Disabled month"); return false; }
            $scope.booking.setDate(_date);
            $scope.date = _date.format("YYYY-MM-DD");
            //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-date'}); }
            if (typeof (dataLayer) !== 'undefined') { dataLayer.push({ 'event': 'waiterAidMessage', 'message': { 'step': 'Choose-date' } }); }
            //updateWidgetStep('Guests','date', $scope.date);
            $scope.moveNext();
        };
        $scope.isFullDate = function (date) {
            return $scope.booking.isFullDate(date);
        };
        $scope.showAllMessage = function () {
            $scope.all_message = !$scope.all_message;
        };


        $scope.moveNext = function () {
            //if($scope.booking.meal.type == 10){
            //    $state.go('guest-details', {}, {location : false});
            //}else {
            if ($scope.booking.meal.type == 9) {
                $scope.goTo('products');
            } else {
                $scope.goTo('time');
            }
            //}
        };
        $scope.isCommentedDay = function (day) {
            //if(full_day_text === '') return false;
            var df = day.format('YYYY-MM-DD');
            //if($scope.booking.isFullDate(day)) return true;
            if (!daily_comments) return false;
            return _.has(daily_comments, df);
        };
        $scope.getDailyComment = function (day) {
            //if(full_day_text === '') return false;
            if (!daily_comments) return false;
            var dd = day.format('YYYY-MM-DD');
            if ($scope.booking.isFullDate(day)) {
                return full_day_text;
            }
            return _.has(daily_comments, dd) ? daily_comments[dd] : false;
        };

        /**
         * initiate meals
         * @param date
         */

        //$scope.setCalendars();
        $scope.setCalendars();
        $scope.closeErrors();
        $scope.pg = 0;
        var nov_month = '2018-11-01';
        $scope.getCalendars = function () {
            var calendars = $scope.calendars;
            /*if($scope.booking.meal.md_override){
                var _dd = moment(angular.copy($scope.date));
                _dd.date(1);
                _dd.add(max_time || 3,"month");
                //console.log(_dd.format("YYYY-MM-DD"));

            }*/
            if ($scope.booking.meal.type == 5) {
                calendars = _.filter(calendars, function (c) {
                    return c.date.isSameOrAfter(nov_month);
                });
                if (_.size(calendars) == 0) {
                    $scope.goTo('meals');
                    return false;
                }
            }
            if (is_mobile) return calendars;
            calendars = _.slice(calendars, $scope.pg, _.size(calendars));
            return calendars;
        };
        $scope.calendar_pg_prev = function () {
            $scope.pg = $scope.pg > 0 ? $scope.pg - 1 : 0;
        };
        $scope.calendar_pg_next = function () {
            if (($scope.pg + 1) > _.size($scope.calendars))
                $scope.pg = _.size($scope.calendars);
            else
                $scope.pg++;
        };
        var activeIndex = getActiveCalendar();
        $scope.active_calendar = $scope.calendars[activeIndex];
        $scope.$on("$viewContentLoaded", function () {
            $timeout(function () {
                tippy(document.querySelectorAll('.ConsumerCalendar-day.with-info'));
                _.forEach(
                    document.querySelectorAll(".select-dropdown-container")
                    , function (el) {
                        if (el.classList.contains("disabled")) return;
                        _.forEach(el.querySelectorAll(".list"), function (lt) {
                            lt.addEventListener("click", function (e) {
                                e.stopPropagation();
                            });
                        });
                        var lbl = el.querySelector('label');
                        lbl.addEventListener("click", function (e) {
                            e.stopPropagation();
                            if (el.classList.contains("show")) {
                                el.classList.remove("show");
                            } else {
                                hideDropDowns();
                                el.classList.add("show");
                            }
                        });
                    });
            }, 0);
        });
        $scope.selectSeatingLength = function (seating) {
            $scope.booking.seating_length = seating.len;
            hideDropDowns();
            // _initTime();
        };
        $scope.selectChildren = function (amt) {
            $scope.booking.children_amount = amt;
            hideDropDowns();
        };
        $scope.selectAmount = function (amount) {
            $scope.booking.amount = amount;
            $scope.setCalendars();
            //_initTime();
            hideDropDowns();
            //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-amount'}); }
            if (typeof (dataLayer) !== 'undefined') { dataLayer.push({ 'event': 'waiterAidMessage', 'message': { 'step': 'Choose-amount' } }); }
        };
        $scope.selectMeal = function (meal) {
            if (!meal.started) return false;
            $scope.booking.setMeal(meal);
            $scope.setCalendars();
            _initTime();
            hideDropDowns();
            //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-meal'}); }
            if (typeof (dataLayer) !== 'undefined') { dataLayer.push({ 'event': 'waiterAidMessage', 'message': { 'step': 'Choose-meal' } }); }
        };
        function hideDropDowns() {
            _.forEach(
                document.querySelectorAll(".select-dropdown-container.show"),
                function (el) {
                    el.classList.remove("show");
                });
        }
        $document.on("click", hideDropDowns);
        $scope.$on("$destroy", function () {
            $document.off("click");
        });
        function getActiveCalendar() {
            return _.findIndex($scope.calendars, function (calendar) {
                return !calendar.isNotSameMonth($scope.booking.date);
            });
        }

        $scope.seating_times = {
            30: "30 m",
            60: "1h 00m",
            75: "1h 15m",
            90: "1h 30m",
            105: "1h 45m",
            120: "2h 00m",
            135: "2h 15m",
            150: "2h 30m",
            165: "2h 45m",
            180: "3h 00m",
            195: "3h 15m",
            210: "3h 30m",
            225: "3h 45m",
            240: "4h 00m",
            255: "4h 15m",
            270: "4h 30m",
            285: "4h 45m",
            300: "5h 00m",
            315: "5h 15m",
            330: "5h 30m",
            345: "5h 45m",
            360: "6h 00m",
            375: "6h 15m",
            390: "6h 30m",
            405: "6h 45m",
            420: "7h 00m",
            435: "7h 15m",
            450: "7h 30m",
            465: "7h 45m",
            480: "8h 00m",
            540: '9h 00m',
            600: '10h 00m',
            660: '11h 00m',
            720: '12h 00m',
            780: '13h 00m',
            840: '14h 00m',
            900: '15h 00m',
            960: '16h 00m',
            1020: '17h 00m',
            1080: '18h 00m',
            1140: '19h 00m',
            1200: '20h 00m',
            1260: '21h 00m',
            1320: '22h 00m',
            1380: '23h 00m',
            1440: '1d',
            2880: '2d',
            4320: '3d',
            5760: '4d',
            7200: '5d',
            8640: '6d',
            10080: '7d'
        };
        $scope.seating_time = allowSeatingTime();
        function allowSeatingTime() {
            var meal = $scope.booking.meal;
            if (!meal || !_.has(meal, 'id')) return false;
            if (meal.seating.allow !== true) return false;
            var available_times = meal.seating.time;
            if (!available_times || _.size(available_times) == 0) return false;
            var return_times = [];
            for (var x in available_times) {
                if (_.has($scope.seating_times, available_times[x])) {
                    return_times.push({ "len": available_times[x], "label": $scope.seating_times[available_times[x]] });
                } else if (!_.isUndefined(meal.mtrd)) {
                    let mtrd = meal.mtrd.split(';');
                    for (let tk in mtrd) {
                        let t = mtrd[tk].split('|');
                        if (t[0] == available_times[x]) {
                            return_times.push({ "len": available_times[x], "label": t[1] });
                        }
                    }
                }
            }
            return return_times.length > 0 ? return_times : false;
        }
        $scope.getLengthLabel = function () {
            var len = _.find($scope.seating_time, { len: $scope.booking.seating_length });
            return len ? len.label : false;
        };
        $scope.$on("$viewContentLoaded", function () {
            if (_.has(_widget_request, 'time')) {
                $scope.setTime(_widget_request.time);
            }
        });

        /*$scope.isFullDate = function(date){
            return _.includes($scope.getBlockedDates(), date.format("YYYY-MM-DD"));
        };*/
        $scope.calendar_next = function (e) {
            activeIndex++;
            //console.log($scope.calendars.length, index);
            if (activeIndex > $scope.calendars.length) activeIndex = $scope.calendars.length - 1;
            $scope.active_calendar = $scope.calendars[activeIndex];
        };
        $scope.calendar_prev = function (e) {
            //var activeIndex = getActiveCalendar();
            activeIndex--;
            if (activeIndex < 0) activeIndex = 0;
            $scope.active_calendar = $scope.calendars[activeIndex];
        };
        updateWidgetStep('Calendar', { averageValue: $scope.booking.meal.avg_gtm_price, totalValue: ($scope.booking.meal.avg_gtm_price * $scope.booking.amount), meal: $scope.booking.meal.name, mealId: $scope.booking.meal.id, amount: $scope.booking.amount });


    }

    angular.module("Waiteraid").controller("calendarCtrl", calendarController);
})();
